<template lang="html">

  <section class="wrapper listado-ofertas-candidato">

    <filtro v-model="filtro" :values="dataTofiltro"></filtro>

    <nav class="breadcrumb container">
      <router-link to="/">Home</router-link>
      <router-link :to="$t('enlaces.ofertas')">Ofertas</router-link>
    </nav>


    <div class="contenedor-ofertas container" v-if="ofertas.length > 0">
      <p>Se ha encontrado {{ofertasFiltradas.length}} {{(ofertasFiltradas.length == 1) ? 'oferta' : 'ofertas'}}</p>

      <div class="texto-intro container" v-if="filtro.practicasInternas">
        <h2 class="simple-title">Antes de empezar</h2>
        <a download href="/static/docs/bases-alumno-practicas-internas.pdf" class="btn -adjunto">BASES DEL PROGRAMA DE PRÁCTICAS INTERNAS</a>
    </div>

      <oferta :key="key" :data="oferta" v-for="(oferta,key) in
        ofertasFiltradas"></oferta>
    </div>

    <div class="view-loading" v-else></div>

  </section>

</template>

<script lang="js">

  import oferta from '@/components/parts/oferta-el';

  import filtro from '@/components/parts/filtro-ofertas';

  import {mapGetters} from 'vuex';

  export default {
    name: 'listado-ofertas',
    data(){
      return{
        filtro : ''
      }
    },
    computed :{
      ...mapGetters({
        ofertas : 'getofertas'
      }),
      ofertasFiltradas(){
        let ofertas = new Array();

        if(!!this.ofertas){

          ofertas = this.ofertas.slice();

          if(!!this.filtro.palabraclave){

              let searchIn = ['descripcion','titulo','empresa','localidad'];

              ofertas = ofertas.filter(o => {
              let can = false;
              searchIn.forEach(c => {
                if(!!o[c]){
                  if (o[c].toLowerCase().includes(this.filtro.palabraclave.toLowerCase())) {
                    can = true;
                  }
                }else{
                  can = false;
                }
              });
              return can;
            })
          }


          if(!!this.filtro.estudios){
            ofertas = ofertas.filter(o => {
              if(!!o.titulaciones_Requeridas){
                return (o.titulaciones_Requeridas.some(t => t == this.filtro.estudios));
              }else{
                return false;
              }
            });
          }

          if(!!this.filtro.ofertasInternacionales){
            ofertas = ofertas.filter(o => o.esInternacional)
          }
          if(!!this.filtro.practicasInternas){
            ofertas = ofertas.filter(o => o.esInterna)
          }
          if(!!this.filtro.provincia){
            ofertas = ofertas.filter(o => {
              if(!!o.provincia){
                return (o.provincia.toLowerCase() == this.filtro.provincia.toLowerCase())
              }else{
                return false;
              }
            });
          }
          if(!!this.filtro.sector){
            ofertas = ofertas.filter(o => o.sectorEmpresa == this.filtro.sector)
          }

        }

        return ofertas;

      },
      dataTofiltro(){

        let data = {
          provincia : [],
          sector : [],
          titulaciones : [],
        };


        if(!!this.ofertas){
          this.ofertas.forEach(o => {

            if(!!o.provincia){
              if(!data.provincia.some(p => p.toLowerCase() == o.provincia.toLowerCase())){
                data.provincia.push(o.provincia);
              }
            }

            if(!!o.sectorEmpresa){
              if(!data.sector.some(p => p.toLowerCase() == o.sectorEmpresa.toLowerCase())){
                data.sector.push(o.sectorEmpresa);
              }
            }

            if(!!o.titulaciones_Requeridas){
              data.titulaciones = data.titulaciones.concat(o.titulaciones_Requeridas);
            }


          });

          data.titulaciones = Array.from(new Set(data.titulaciones))
          data.titulaciones= [...new Set(data.titulaciones)]

          data.titulaciones.sort();
          data.provincia.sort();
          data.sector.sort();



        }

        return data;

      }
    },
    components : {
      'oferta' : oferta,
      'filtro' : filtro
    }
  }
</script>

<style scoped lang="scss">

  p{
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/listado-ofertas.vue